import { trackEvent } from "../utils/track-event";
import type {
  CarouselEventBaseProps,
  CarouselEventProps,
  CarouselItemType,
  TrackingEvent,
  TrackingEventResponse,
} from "../utils/types";
import { mapCarouselItem, mapCarouselItems } from "../utils/helpers";

type CarouselItemSelectedEventProps = CarouselEventBaseProps & {
  items: CarouselItemType[];
  itemId: string;
};

export type CarouselItemSelectedEvent = TrackingEvent<
  "Carousel Item Selected",
  Omit<CarouselEventProps, "visible_items">
>;

export async function trackCarouselItemSelectedEvent({
  carouselId,
  carouselPosition,
  shopType,
  title,
  imageUrl,
  subtitle,
  contentType,
  itemId,
  items,
  targetLink,
  targetType,
  responseSourceType,
  resultId,
  gated,
  tab,
}: CarouselItemSelectedEventProps): TrackingEventResponse {
  const mappedItems = mapCarouselItems(items);
  const itemPosition =
    items.findIndex((value) => "id" in value && value.id === itemId) + 1;
  const item = items.find((value) => "id" in value && value.id === itemId);

  if (!item) {
    return;
  }

  return await trackEvent("Carousel Item Selected", {
    props: {
      carousel_content_type: contentType,
      carousel_id: carouselId,
      carousel_position: carouselPosition,
      item: mapCarouselItem(item, itemPosition),
      items: mappedItems,
      num_items: mappedItems.length,
      shop_type: shopType,
      title,
      image_url: imageUrl,
      subtitle,
      target_link: targetLink,
      target_type: targetType,
      response_source_type: responseSourceType,
      result_id: resultId,
      gated,
      tab,
    },
    withRequestSource: true,
  });
}
